<section class="top-section">
  <div class="container">
    <div class="row profile-wrap" [class.profile-wrap--with-user]="userData">
      <!-- ------------ LEFT column: Sign-up/Sign-in (when not logged in) OR Team profile (when logged in) - only one is shown -->
      <div class="col-lg-6 col-md-7 col-12">
        <ng-container *ngIf="!userData; else teamProfileTpl">
          <div class="tabs">
            <ul>
              <li [ngClass]="{'active': activeTab === TABS.SIGN_UP}">
                <p (click)="setActiveTab(TABS.SIGN_UP)">{{'TEAM_SIGN_UP.STEP' | translate}}</p>
              </li>
              <li [ngClass]="{'active': activeTab === TABS.SIGN_IN}">
                <p (click)="setActiveTab(TABS.SIGN_IN)">{{'TEAM_SIGN_IN.STEP' | translate}}</p>
              </li>
            </ul>
          </div>
          <div class="tabs-content">
            <ng-container *ngIf="activeTab === TABS.SIGN_UP">
              <app-sign-up-team (stepEmit)="setCurrentStep($event)"></app-sign-up-team>
            </ng-container>
            <ng-container *ngIf="activeTab === TABS.SIGN_IN">
              <app-login-team [henterPantMode]="true" (getSubscriptionEmit)="getUserSubscription()"></app-login-team>
            </ng-container>
          </div>
        </ng-container>
        <ng-template #teamProfileTpl>
          <app-team-profile [userData]="userData"></app-team-profile>
        </ng-template>
      </div>

      <!-- ------------ RIGHT column MEMBER -->
      <div class="offset-lg-1 col-lg-5 col-md-5 col-12" *ngIf="!userData">
        <app-become-member [stepData]="currentStep"></app-become-member>
      </div>
      <!-- ------------ RIGHT column MEMBER END -->

      <!-- ------------ RIGHT column SUBSCRIPTION -->
      <div class="offset-lg-1 col-lg-5 col-md-5 col-12" *ngIf="userData">
        <div class="payment-status-wrap" *ngIf="paymentStatus">
          <div *ngIf="paymentStatus === 'success' && paymentVerified" class="success-message">
            ✅ Payment was successful and verified.
          </div>

          <div *ngIf="paymentStatus === 'success' && !paymentVerified" class="error-message">
            ⚠️ Payment could not be verified.
          </div>

          <div *ngIf="paymentStatus === 'cancelled'" class="cancel-message">
            ❌ Payment was cancelled.
          </div>
        </div>
        <app-team-subscription [userData]="userData" [subscriptionData]="subscriptionData"
                               (getProjectEmit)="getUser()"></app-team-subscription>
      </div>
      <!-- ------------ RIGHT column SUBSCRIPTION END -->
    </div>
  </div>
</section>

